import * as React from 'react';
import { observer } from 'mobx-react';
import ImageStore from './ImageStore';

interface Props {
  src: string;
  alt: string;
  style: string;
}

class Image extends React.Component<Props> {
  imageStore: ImageStore = new ImageStore();

  render() {
    const { src, alt, style } = this.props;

    const onErrorHandle = () => {
      this.imageStore.error();
    };

    switch (this.imageStore.state.kind) {
      case 'loading':
        return (
          <img
            src={src}
            alt={alt}
            data-test-image={alt}
            onError={onErrorHandle}
            className={style}
          />
        );
      case 'error':
        return <></>;
    }
  }
}

export default observer(Image);
